export const SET_MISC_MY_RECORDS_TEMPLATE = 'SET_MISC_MY_RECORDS_TEMPLATE'
export const SET_MISC_MY_RECORDS_TEMPLATE_LOADING = 'SET_MISC_MY_RECORDS_TEMPLATE_LOADING'
export const SET_MISC_MY_RECORDS_ITEMS = 'SET_MISC_MY_RECORDS_ITEMS'
export const SET_MISC_MY_RECORDS_LOADING = 'SET_MISC_MY_RECORDS_LOADING'
export const SET_MISC_MY_RECORDS_ERROR = 'SET_MISC_MY_RECORDS_ERROR'
export const SET_MISC_MY_RECORDS_LAST_REQUEST_ID = 'SET_MISC_MY_RECORDS_LAST_REQUEST_ID'
export const SET_MISC_MY_RECORDS_FILTER = 'SET_MISC_MY_RECORDS_FILTER'
export const SET_MISC_MY_RECORDS_ADVANCED_FILTER = 'SET_MISC_MY_RECORDS_ADVANCED_FILTER'
export const RESET_MISC_MY_RECORDS_FILTERS = 'RESET_MISC_MY_RECORDS_FILTERS'
export const SET_MISC_MY_RECORDS_SELECTED_RECORD_ID = 'SET_MISC_MY_RECORDS_SELECTED_RECORD_ID'
export const SET_MISC_MY_RECORDS_DRAWER = 'SET_MISC_MY_RECORDS_DRAWER'
export const SET_MISC_MY_RECORDS_DRAWER_LOADING = 'SET_MISC_MY_RECORDS_DRAWER_LOADING'
export const SET_MISC_MY_RECORDS_DRAWER_ERROR = 'SET_MISC_MY_RECORDS_DRAWER_ERROR'
export const SET_MISC_AMENDMENT_MODAL_OPEN = 'SET_MISC_AMENDMENT_MODAL_OPEN'
export const SET_MISC_AVAILABLE_AMENDMENTS = 'SET_MISC_AVAILABLE_AMENDMENTS'
export const SET_MISC_AMENDMENTS_LOADING = 'SET_MISC_AMENDMENTS_LOADING'

export const initialFilters = {
  search: '',
  registrationDateStart: null,
  registrationDateEnd: null,
  advancedFilters: {},
}

export const initialState = {
  template: null,
  templateLoading: false,
  items: [],
  totalCount: 0,
  loading: false,
  error: null,
  lastRequestId: null,
  filters: initialFilters,
  selectedRecordId: null,
  drawerData: null,
  drawerLoading: false,
  drawerError: null,
  amendmentModalOpen: false,
  availableAmendments: [],
  amendmentsLoading: false,
}

const MiscellaneousMyRecordsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MISC_MY_RECORDS_TEMPLATE:
      return { ...state, template: action.template, templateLoading: false }
    case SET_MISC_MY_RECORDS_TEMPLATE_LOADING:
      return { ...state, templateLoading: action.loading }
    case SET_MISC_MY_RECORDS_ITEMS:
      return { ...state, items: action.items, totalCount: action.totalCount }
    case SET_MISC_MY_RECORDS_LOADING:
      return { ...state, loading: action.loading }
    case SET_MISC_MY_RECORDS_ERROR:
      return { ...state, error: action.error, loading: false }
    case SET_MISC_MY_RECORDS_LAST_REQUEST_ID:
      return { ...state, lastRequestId: action.requestId }
    case SET_MISC_MY_RECORDS_FILTER:
      return { ...state, filters: { ...state.filters, [action.key]: action.value } }
    case SET_MISC_MY_RECORDS_ADVANCED_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          advancedFilters: { ...state.filters.advancedFilters, [action.fieldName]: action.value },
        },
      }
    case RESET_MISC_MY_RECORDS_FILTERS:
      return { ...state, filters: initialFilters, items: [], totalCount: 0, drawerData: null, drawerLoading: false, drawerError: null }
    case SET_MISC_MY_RECORDS_SELECTED_RECORD_ID:
      return {
        ...state,
        selectedRecordId: action.recordId,
        drawerData: action.recordId === null ? null : state.drawerData,
        drawerLoading: action.recordId === null ? false : state.drawerLoading,
        drawerError: action.recordId === null ? null : state.drawerError,
      }
    case SET_MISC_MY_RECORDS_DRAWER:
      return { ...state, drawerData: action.data, drawerLoading: false }
    case SET_MISC_MY_RECORDS_DRAWER_LOADING:
      return { ...state, drawerLoading: action.loading }
    case SET_MISC_MY_RECORDS_DRAWER_ERROR:
      return { ...state, drawerError: action.error, drawerLoading: false }
    default:
      return state
  }
}

export default MiscellaneousMyRecordsReducer
